module.exports = "https://static.wmbcdn.com/uniweb/images/33cbc999515c88aa67e0bdd6c65f00af.svg";